/**************************************************
 * Nombre:       Apartado_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import Tarjeta_Indicadores from "../Tarjeta/Tarjeta_Indicadores";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Apartado_Indicadores = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: 24,
                                fontWeight: 700,
                                color: '#1B0B3B',
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                lineHeight: 1.3
                            }}>
                                {item.tituloIndicadores}<span
                                style={{color: '#9049F5'}}> {item.rosadotituloIndicadores}</span>

                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={sCell ? 2 : 6}
                            sx={{mt: 6}}
                        >

                            {item && item.indicadores && item.indicadores.map((item, index) => (
                                <Grid container size={{xs: 6, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Indicadores item={item}/>
                                </Grid>
                            ))}

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Apartado_Indicadores

const items = [
    {
        nombre: 'Uno',
        dato: 15000,
        referencia: 'New Times'
    },

    {
        nombre: 'Uno',
        dato: 15000,
        referencia: 'New Times'
    },

    {
        nombre: 'Uno',
        dato: 15000,
        referencia: 'New Times'
    },
]